import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const IndicatorsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        id="Vector 113"
        d="M10 18C6.48 18 3.25 17.97 2.12 17.97C1 17.97 1 17.97 1 16.94C1 15.91 1 4.08 1 3.05C1 2.02 1 2.02 2.12 2.02C3.25 2.02 6.62 2.02 6.62 2.02C6.62 2.02 7.18 1 8.31 1C9.43 1 10 2.02 10 2.02C10 2.02 13.37 2.02 14.5 2.02C15.62 2.02 15.62 2.02 15.62 3.05C15.62 4.08 15.62 9.22 15.62 9.22M10 9.22L10 18L10 19L19 19L19 9.22L15.62 9.22L15.06 9.22L10 9.22Z"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        fill="none"
      />
      <path
        id="Vector 114"
        d="M4.28 2L4.28 4.5L12 4.5L12 2M3 7L3 9M5.57 8L5.57 9M8.14 7.5L8.14 9M3 13C3 15 4 15.5 5.5 15.5C7 15.5 8 15 8 13C8 11 7 10.5 5.5 10.5C4 10.5 3 11 3 13ZM5.5 10.5C5.5 11.28 5.28 12.72 5.57 13C6 13.4 7.99 13.13 8 13"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
        fill="none"
      />
      <path
        id="Vector 115"
        d="M12.8 11L16.19 11M12.23 14C12.54 14.33 13.05 14.33 13.36 14C13.68 13.66 13.68 13.13 13.36 12.8C13.05 12.46 12.54 12.46 12.23 12.8C11.92 13.13 11.92 13.66 12.23 14ZM15.63 14C15.94 14.33 16.45 14.33 16.76 14C17.07 13.66 17.07 13.13 16.76 12.8C16.45 12.46 15.94 12.46 15.63 12.8C15.31 13.13 15.31 13.66 15.63 14ZM13.36 17L12.23 17L12.23 15.8L13.36 15.8L13.36 17ZM15.63 17L16.76 17L16.76 15.8L15.63 15.8L15.63 17Z"
        stroke="currentColor"
        strokeOpacity="1.000000"
        strokeWidth="1.000000"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
};
